// @flow strict
import * as React from 'react';
import useSubmitIAPVote, { type UseSubmitIAPVoteArgs } from './useSubmitIAPVote';
import type { ReportStage } from './ReportModal';

const useReportFlow = (args: UseSubmitIAPVoteArgs) => {
  const [stage, setStage] = React.useState<ReportStage>('panel');
  const submitVote = useSubmitIAPVote(args);
  return React.useMemo(
    () => [
      stage,
      () =>
        submitVote()
          .then(() => {
            setStage('thankyou');
          })
          .catch(() => {
            setStage('error');
          }),
    ],
    [stage, submitVote],
  );
};

export default useReportFlow;
